/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewAggregationFindingAssets } from './CRSFSecReviewAggregationFindingAssets';
import {
    CRSFSecReviewAggregationFindingAssetsFromJSON,
    CRSFSecReviewAggregationFindingAssetsFromJSONTyped,
    CRSFSecReviewAggregationFindingAssetsToJSON,
} from './CRSFSecReviewAggregationFindingAssets';

/**
 * 
 * @export
 * @interface CRSFSecReviewAggregationFindings
 */
export interface CRSFSecReviewAggregationFindings {
    /**
     * 
     * @type {Array<CRSFSecReviewAggregationFindingAssets>}
     * @memberof CRSFSecReviewAggregationFindings
     */
    assets: Array<CRSFSecReviewAggregationFindingAssets>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAggregationFindings
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewAggregationFindings
     */
    datapoint: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewAggregationFindings
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewAggregationFindings
     */
    level: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewAggregationFindings
     */
    name: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewAggregationFindings
     */
    recommendation: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewAggregationFindings
     */
    references: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewAggregationFindings
     */
    risk_score: number;
}

/**
 * Check if a given object implements the CRSFSecReviewAggregationFindings interface.
 */
export function instanceOfCRSFSecReviewAggregationFindings(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assets" in value;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "datapoint" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "level" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "recommendation" in value;
    isInstance = isInstance && "references" in value;
    isInstance = isInstance && "risk_score" in value;

    return isInstance;
}

export function CRSFSecReviewAggregationFindingsFromJSON(json: any): CRSFSecReviewAggregationFindings {
    return CRSFSecReviewAggregationFindingsFromJSONTyped(json, false);
}

export function CRSFSecReviewAggregationFindingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewAggregationFindings {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assets': ((json['assets'] as Array<any>).map(CRSFSecReviewAggregationFindingAssetsFromJSON)),
        'count': json['count'],
        'datapoint': json['datapoint'],
        'description': json['description'],
        'level': json['level'],
        'name': json['name'],
        'recommendation': json['recommendation'],
        'references': json['references'],
        'risk_score': json['risk_score'],
    };
}

export function CRSFSecReviewAggregationFindingsToJSON(value?: CRSFSecReviewAggregationFindings | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assets': ((value.assets as Array<any>).map(CRSFSecReviewAggregationFindingAssetsToJSON)),
        'count': value.count,
        'datapoint': value.datapoint,
        'description': value.description,
        'level': value.level,
        'name': value.name,
        'recommendation': value.recommendation,
        'references': value.references,
        'risk_score': value.risk_score,
    };
}

